import request from 'lib/request';

export interface Response {
  code: number;
  msg: string;
}

export async function announceRaffle(vanity_url: string) {
  const res = await request<Response>('/raffle/announce', {
    method: 'POST',
    data: {
      vanity_url,
    },
  });
  return res;
}
